/**
 * Browser configuration, read once and validated loudly.
 *
 * Anything prefixed VITE_ is compiled into the bundle and served to
 * whoever loads the page, so only the publishable key belongs here.
 * If you find yourself wanting the service role key in this file, the
 * work belongs in a script or an edge function instead.
 */

function required(name: string, value: string | undefined): string {
  if (value === undefined || value.trim() === '') {
    throw new Error(
      `${name} is not set. Copy web/.env.example to web/.env.local and fill it in.`,
    )
  }
  return value.trim()
}

export const env = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  supabaseKey: required(
    'VITE_SUPABASE_PUBLISHABLE_KEY',
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  ),
  entraEnabled: import.meta.env.VITE_ENTRA_ENABLED === 'true',
} as const
